import ApiClient from '@src/lib/api_client'
import { API } from '@src/lib/api_path'
import SessionManager from '@src/lib/session_manager'

export interface AIConversationReportRequest {
  reportText: string
  conversationFingerprint: string
}

export class AIConversationReportService {
  apiClient: ApiClient = new ApiClient()

  createReport (request: AIConversationReportRequest): Promise<void> {
    const endpoint = SessionManager.Instance.isManager() ? API.TRAINERS_API.AI_CONVERSATION_REPORTS : API.MEMBERS_API.AI_CONVERSATION_REPORTS

    return this.apiClient.post(endpoint, {
      ai_conversation_report: {
        report_text: request.reportText,
        conversation_fingerprint: request.conversationFingerprint
      }
    }).then(() => Promise.resolve())
  }
}
